export const CameraConfigComment = {
  MAX_WIDTH: 1024,
  MAX_HEIGHT: 1024,
  QUALITY: 95
}
